/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import { Remove } from "@material-ui/icons";

// PAGES
import DashboardPage from "views/Dashboard/Dashboard.js";
import MyAccount from "views/Admin/MyAccount.js";
import ProfilesListAdmin from "views/Admin/ProfilesListAdmin.js";
import GenderListAdmin from "views/Admin/GenderListAdmin.js";
import UserAdminList from "views/Admin/UsersAdminList.js";
import StudentAdminList from "views/Admin/StudentAdminList.js";
import PersonalAdminList from "views/Admin/PersonalAdminList.js";
import ClaseListAdmin from "views/Admin/ClaseListAdmin.js";
import ParentescoListAdmin from "views/Admin/ParentescoListAdmin.js";

/*import CountriesListAdmin from "views/Admin/CountriesListAdmin.js";
import StatesListAdmin from "views/Admin/StatesListAdmin.js";
import CitiesListAdmin from "views/Admin/CitiesListAdmin.js";*/

const dashboardRoutes = [
  {
    id: 0,
    subId: "",
    path: "/dashboard",
    name: "Inicio",
    rtlName: "لوحة القيادة",
    icon: Remove,
    component: DashboardPage,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // USER list
    id: 0,
    subId: "",
    path: "/studentadminlist",
    name: "Estudiantes",
    rtlName: "",
    icon: Remove,
    component: StudentAdminList,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // USER list
    id: 0,
    subId: "",
    path: "/personaladminlist",
    name: "Personal",
    rtlName: "",
    icon: Remove,
    component: PersonalAdminList,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // USER list
    id: 0,
    subId: "",
    path: "/useradminlist",
    name: "Usuarios del sistema",
    rtlName: "",
    icon: Remove,
    component: UserAdminList,
    layout: "/superadmin",
    submenu: [],
  },
  {
    id: 0,
    subId: "",
    path: "/myaccount",
    name: "Mi perfil",
    rtlName: "لوحة القيادة",
    icon: Remove,
    component: MyAccount,
    layout: "/superadmin",
    submenu: [],
  },
  {
    id: 1,
    subId: "",
    path: "",
    name: "Administración",
    rtlName: "",
    icon: Remove,
    component: "",
    layout: "/superadmin",
    submenu: [
      {
        subId: 1,
        name: "Perfiles",
        path: "/profilelist",
      },
      {
        subId: 1,
        name: "Género",
        path: "/genderlist",
      },
      {
        subId: 1,
        name: "Clase",
        path: "/claselist",
      },
      {
        subId: 1,
        name: "Parentesco",
        path: "/parentescolist",
      },
    ],
  },
  {
    // SUBMENU Profiles list
    id: "",
    subId: 1,
    path: "/profilelist",
    name: "",
    rtlName: "",
    icon: "",
    component: ProfilesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU gender list
    id: "",
    subId: 1,
    path: "/genderlist",
    name: "",
    rtlName: "",
    icon: "",
    component: GenderListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU clase list
    id: "",
    subId: 1,
    path: "/claselist",
    name: "",
    rtlName: "",
    icon: "",
    component: ClaseListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU parentesco list
    id: "",
    subId: 1,
    path: "/parentescolist",
    name: "",
    rtlName: "",
    icon: "",
    component: ParentescoListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  /*{
    // SUBMENU MENU list
    id: "",
    subId: 1,
    path: "/modules",
    name: "",
    rtlName: "",
    icon: "",
    component: MenuListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU PROFILE/PRIVILEGES list
    id: "",
    subId: 1,
    path: "/profileprivileges",
    name: "",
    rtlName: "",
    icon: "",
    component: ProfilePrivileges,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU COUNTRIES list
    id: "",
    subId: 1,
    path: "/countries",
    name: "",
    rtlName: "",
    icon: "",
    component: CountriesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU STATES list
    id: "",
    subId: 1,
    path: "/states",
    name: "",
    rtlName: "",
    icon: "",
    component: StatesListAdmin,
    layout: "/superadmin",
    submenu: [],
  },
  {
    // SUBMENU CITIES list
    id: "",
    subId: 1,
    path: "/cities",
    name: "",
    rtlName: "",
    icon: "",
    component: CitiesListAdmin,
    layout: "/superadmin",
    submenu: [],
  }*/
];

export default dashboardRoutes;
